import { render } from "./ChipFilters.vue?vue&type=template&id=324b8fa5&ts=true"
import script from "./ChipFilters.vue?vue&type=script&lang=ts"
export * from "./ChipFilters.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__